const initialState = {
  prizes: null,
  eventPoints: null
}

export default initialState;
